import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export interface HoverActionIconButtonProps {
  show: boolean;
  ariaLabel: string;
  onClick: () => void;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  size?: 'small' | 'medium' | 'large';
  tooltipTitle?: string;
  tooltipArrow?: boolean;
  disabled?: boolean;
}

const HoverActionIconButton: React.FC<HoverActionIconButtonProps> = ({
  show,
  ariaLabel,
  onClick,
  children,
  sx,
  size = 'small',
  tooltipTitle,
  tooltipArrow = false,
  disabled = false,
}) => {
  if (!show) {
    return null;
  }

  const button = (
    <IconButton
      size={size}
      aria-label={ariaLabel}
      onClick={onClick}
      sx={sx}
      disabled={disabled}
    >
      {children}
    </IconButton>
  );

  if (!tooltipTitle) {
    return button;
  }

  return (
    <Tooltip title={tooltipTitle} arrow={tooltipArrow}>
      {button}
    </Tooltip>
  );
};

export default HoverActionIconButton;
